import React from "react";
import { Link } from "react-router-dom"; // import Link
import headerBg from "./assets/picOne.png";

const MetrologyServices = () => {
  return (
    <div className="about-us">
      {/* === Header Section === */}
      <section className="about-header">
        <div className="overlay">
          <h1 className="page-title">Overview – Metrology</h1>
          <p className="intro-line">Ensuring accurate measurement and traceability across industries.</p>
        </div>
      </section>

      {/* === Overview Section === */}
      <section className="overview-section">
        <div className="overview-content">
          <p className="subtitle">
            Metrology is the science of measurement. It is concerned with the ways and means by which measurements are carried out (procedures, equipment and their environment), the accuracy to which they are determined (errors/ uncertainties) and to a lesser extent the use to which they are put (application).
          </p>
          <p className="subtitle">
            Metrology activities are undertaken by the Metrology Department, whose main objective is to control, through the Metrology Act (No. 10 of 2016), the use of instruments, weights and measures in commercial and industrial sectors of the economy to ensure traceability to international standards through calibration and verification activities. Such activities also ensure consumer protection from unfair trading practices through measurements, and promote competitiveness in a trading environment both domestically and internationally.
          </p>
          <p className="subtitle">
            The main Metrology services being offered are Verification and Inspection Services, and Calibration Services.
          </p>
        </div>
      </section>

      {/* === Main Services Section === */}
      <section className="content-section">
        <h2 className="section-title">Main Metrology Services</h2>
        <div className="services-cards">

          {/* Verification and Inspection */}
          <Link to="/QualityManagement" className="service-card">
            <h3>Verification and Inspection Services</h3>
            <p>
              Ensures that measurement instruments in commercial and industrial sectors are accurate, traceable, and compliant with standards. Supports consumer protection and fair trade.
            </p>
          </Link>

          {/* Calibration Services */}
          <Link to="/MetrologyTraining" className="service-card">
            <h3>Calibration Services</h3>
            <p>
              Provides calibration of measurement instruments to national and international standards, ensuring reliability, accuracy, and traceability for industry and laboratories.
            </p>
          </Link>

        </div>
      </section>

      {/* === Inline CSS === */}
      <style>{`
        .about-us { font-family: Arial, sans-serif; color: #333; line-height: 1.6; }

        /* Header */
        .about-header {
          background-image: url(${headerBg});
          background-size: cover;
          background-position: center;
          height: 45vh;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .overlay {
          background: rgba(0,0,0,0.55);
          padding: 40px;
          text-align: center;
          color: white;
          width: 90%;
          max-width: 1200px;
          border-radius: 12px;
        }

        .page-title { font-size: 2.2rem; font-weight: bold; margin-bottom: 10px; }
        .intro-line { font-size: 1rem; margin-top: 5px; font-weight: 500; }

        /* Overview */
        .overview-section { padding: 40px 20px; max-width: 1400px; margin: auto; text-align: left; }
        .overview-content { margin-bottom: -70px; }
        .subtitle { font-size: 1rem; line-height: 1.6; margin-bottom: 20px; }

        /* Services Section */
        .content-section { padding: 40px 20px; max-width: 1200px; margin: auto; }
        .section-title { font-size: 1.5rem; color: #ff6600; margin-bottom: 25px; text-align: center; }

        .services-cards { display: flex; flex-wrap: wrap; gap: 20px; justify-content: center; }
        .service-card {
          flex: 1 1 300px;
          background: #f9f9f9;
          border: 2px solid #ff6600;
          border-radius: 12px;
          padding: 25px;
          transition: all 0.3s ease;
          text-align: center;
          text-decoration: none; /* remove underline for links */
          color: inherit; /* inherit text color */
        }
        .service-card h3 { margin-bottom: 15px; font-size: 1.2rem; color: #333; }
        .service-card p { font-size: 1rem; line-height: 1.5; }

        .service-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 25px rgba(0,0,0,0.15);
        }

        /* Responsive */
        @media screen and (max-width: 768px) {
          .overlay { padding: 25px; }
          .page-title { font-size: 1.8rem; }
          .overview-section { padding: 30px 15px; }
          .content-section { padding: 30px 15px; }
          .services-cards { flex-direction: column; align-items: center; }
        }
      `}</style>
    </div>
  );
};

export default MetrologyServices;
